"use strict";

/*
  Status:
  0 = unknown
  1 = noFlow
  2 = flow
*/

/*check if delta is below 0.25 dl*/
function isNear(val1, val2) {
    //console.log("DEBUG val1:", val1, " val2:", val2, "res?:", val1 === val2);
    return val1 === val2;
    //return Math.abs(val1 - val2) < 0.000025;
}

module.exports = function (config, result) {

    // first check that we have desilitre pointer available
    var pointersMatches = 0;
    if (config.digits.enabled) {
        if (config.digits.positions[config.digits.positions.length - 1].precision == 0.0001 // first check that we have deciliter available
            && config.previousDigits // previous digits needs to exist
            && result.decimal.value != null // new and previous pointers should have meaningfull value
            && config.previousDigits.decimal.value != null) {
            // first check that desilitre matches
            //let currentD = result.digits[result.digits.length - 1];
            //let prevD = config.previousDigits.digits[config.previousDigits.digits.length - 1];
            //if (currentD.result != -1 && prevD.result != -1) {
            var res = isNear(result.decimal.value, config.previousDigits.decimal.value);
            if (res) {
                return { status: 1 }; // if desilitre pointers match and possible others also -> return noflow
            } else { // desilitre pointer has moved -> some sort of flow definately
                return { status: 2 };
            }
            //} else { return { status: 0 } }
        } else {
            return { status: 0 }
        }
    } else {
        return { status: 0 }
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/check-flow.js
// module id = 839
// module chunks = 0